import { makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        gap: '1rem',
        width: '100%',
        '& > div': {
            flexWrap: 'wrap',
            display: 'flex',
        }
    },
    infoContainer: {
        display: 'flex',
        gap: '2rem'
    },
    contentWithImageContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        minWidth: '300px',
        width: "25%",
        padding: '1rem',
        height: '5rem',
        '& img': {
            width: '4.5rem',
            maxHeight: '4.5rem',
        }
    }
}))

const CourseDesign = ({ courseDesign, ...props }) => {

    const classes = useStyles();

    return (
        <section className={classes.root}>
            <h1>Who is this course designed for?</h1>
            <div className={classes.infoContainer}>
                {courseDesign?.map((val, idx) => (
                    <div key={val.value + idx} className={`${classes.contentWithImageContainer}`}>
                        <img src={val.imagePath} />
                        <h4>{val.value}</h4>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default CourseDesign;